import * as React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';
export var WindowMinimizeIcon = /*#__PURE__*/createSvgIcon({
  svg: function svg(_ref) {
    var classes = _ref.classes;
    return /*#__PURE__*/React.createElement("svg", {
      role: "presentation",
      focusable: "false",
      viewBox: "8 8 16 16",
      className: classes.svg
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 16v-1h12v1H10z"
    }));
  },
  displayName: 'WindowMinimizeIcon'
});
//# sourceMappingURL=WindowMinimizeIcon.js.map
